/* Fiche produit : galerie, quantité et sélection de variante. */

class SiritoGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.sirito-product__slide'));
    this.indicators = Array.from(this.querySelectorAll('.sirito-product__indicator'));
    if (this.slides.length < 2) return;

    this.index = 0;

    const prev = this.querySelector('[data-sirito-prev]');
    const next = this.querySelector('[data-sirito-next]');
    if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
    if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

    this.indicators.forEach((btn) => {
      btn.addEventListener('click', () => this.goTo(Number(btn.dataset.index)));
    });

    // Les flèches du clavier font défiler la galerie quand elle a le focus.
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      if (event.key === 'ArrowRight') this.goTo(this.index + 1);
    });
  }

  goTo(next) {
    const target = ((next % this.slides.length) + this.slides.length) % this.slides.length;
    if (target === this.index) return;

    this.slides[this.index].classList.remove('sirito-product__slide--active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.slides[target].classList.add('sirito-product__slide--active');
    this.slides[target].removeAttribute('aria-hidden');

    if (this.indicators.length) {
      this.indicators[this.index].classList.remove('sirito-product__indicator--active');
      this.indicators[this.index].setAttribute('aria-current', 'false');
      this.indicators[target].classList.add('sirito-product__indicator--active');
      this.indicators[target].setAttribute('aria-current', 'true');
    }

    this.index = target;
  }

  // Permet aux autres composants d'afficher l'image d'une variante.
  showMedia(mediaId) {
    const position = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
    if (position > -1) this.goTo(position);
  }
}

customElements.define('sirito-gallery', SiritoGallery);

/* --- Sélecteur de quantité --- */

(function initQuantity() {
  const input = document.querySelector('.sirito-product__qty-input');
  if (!input) return;

  document.querySelectorAll('[data-sirito-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const step = Number(btn.dataset.siritoQty);
      const value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();

/* --- Variantes : la sélection met à jour l'identifiant envoyé au panier --- */

(function initVariants() {
  const source = document.querySelector('[data-sirito-variants]');
  const form = document.getElementById('SiritoProductForm');
  if (!source || !form) return;

  let variants;
  try {
    variants = JSON.parse(source.textContent);
  } catch (error) {
    // Sans données exploitables, le formulaire garde la variante rendue côté serveur.
    return;
  }

  const idInput = form.querySelector('input[name="id"]');
  const addButton = form.querySelector('.sirito-product__add');
  const priceEl = document.querySelector('.sirito-product__price-current');

  const currentOptions = () =>
    Array.from(form.querySelectorAll('.sirito-product__option-input:checked'))
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

  const update = () => {
    const selected = currentOptions();
    const match = variants.find((variant) =>
      variant.options.every((option, index) => option === selected[index])
    );

    if (!match) {
      if (addButton) addButton.disabled = true;
      return;
    }

    if (idInput) {
      idInput.value = match.id;
      idInput.disabled = !match.available;
    }
    if (addButton) addButton.disabled = !match.available;
    if (priceEl && match.price != null) {
      // Shopify renvoie les montants en centimes.
      priceEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
      }).format(match.price / 100);
    }

    // L'adresse reflète la variante choisie pour que le lien reste partageable.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());

    const gallery = document.querySelector('sirito-gallery');
    if (gallery && match.featured_media) gallery.showMedia(match.featured_media.id);
  };

  form.querySelectorAll('.sirito-product__option-input').forEach((input) => {
    input.addEventListener('change', update);
  });
})();
